<template>
	<v-dialog v-model="dialogModel" :max-width="width" persistent>
		<v-card class="confirmation-dialog-card" elevation="8">
			<v-card-title class="confirmation-dialog-header">
				<span class="confirmation-dialog-title">{{ title }}</span>
				<v-btn icon="mdi-close" variant="text" size="small" @click="close" class="close-button"></v-btn>
			</v-card-title>
			
			<v-divider class="header-divider"></v-divider>
			
			<v-card-text class="confirmation-dialog-content">
				<div class="content-wrapper">
					<div class="icon-container">
						<svg class="warning-icon" width="64" height="64" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M17.88 82.0151H78.12C84.28 82.0151 88.12 75.3351 85.04 70.0151L54.92 17.9751C51.84 12.6551 44.16 12.6551 41.08 17.9751L10.96 70.0151C7.88 75.3351 11.72 82.0151 17.88 82.0151ZM48 54.0151C45.8 54.0151 44 52.2151 44 50.0151V42.0151C44 39.8151 45.8 38.0151 48 38.0151C50.2 38.0151 52 39.8151 52 42.0151V50.0151C52 52.2151 50.2 54.0151 48 54.0151ZM52 70.0151H44V62.0151H52V70.0151Z" fill="#FFB400"/>
						</svg>
					</div>
					<div class="text-content">
						<h3 class="confirmation-heading">{{ heading }}</h3>
						<p class="confirmation-message">{{ message }}</p>
					</div>
				</div>
			</v-card-text>
			
			<v-card-actions class="confirmation-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn 
					variant="outlined" 
					:color="cancelButtonColor"
					class="cancel-button"
					@click="close"
				>
					{{ cancelButtonText }}
				</v-btn>
				<v-btn 
					variant="flat" 
					:color="confirmButtonColor" 
					class="confirm-button"
					@click="confirm"
				>
					{{ confirmButtonText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'ConfirmationDialog',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: 'Confirmation'
		},
		heading: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: 'Are you sure you want to proceed?'
		},
		confirmButtonText: {
			type: String,
			default: 'Confirm'
		},
		confirmButtonColor: {
			type: String,
			default: 'success'
		},
		cancelButtonText: {
			type: String,
			default: 'Cancel'
		},
		cancelButtonColor: {
			type: String,
			default: 'grey'
		},
		width: {
			type: [Number, String],
			default: '500px'
		}
	},
	emits: ['update:show', 'confirm', 'cancel'],
	computed: {
		dialogModel: {
			get() {
				return this.show
			},
			set(value) {
				this.$emit('update:show', value)
			}
		}
	},
	methods: {
		confirm() {
			this.$emit('confirm')
			this.dialogModel = false
		},
		close() {
			this.$emit('cancel')
			this.dialogModel = false
		}
	}
}
</script>

<style scoped>
.confirmation-dialog-card {
	border-radius: 12px;
	overflow: hidden;
}

.confirmation-dialog-header {
	padding: 24px 24px 16px 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: auto;
}

.confirmation-dialog-title {
	font-size: 20px;
	font-weight: 500;
	color: #1a1a1a;
	margin: 0;
}

.close-button {
	color: #666;
}

.header-divider {
	margin: 0;
	border-color: #e0e0e0;
}

.confirmation-dialog-content {
	padding: 32px 24px;
}

.content-wrapper {
	display: flex;
	align-items: flex-start;
	gap: 16px;
}

.icon-container {
	flex-shrink: 0;
}

.warning-icon {
	width: 64px;
	height: 64px;
	flex-shrink: 0;
}

.text-content {
	flex: 1;
	padding-top: 8px;
}

.confirmation-heading {
	font-size: 18px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 8px 0;
	line-height: 1.4;
}

.confirmation-message {
	font-size: 14px;
	color: #757575;
	margin: 0;
	line-height: 1.5;
}

.confirmation-dialog-actions {
	padding: 16px 24px 24px 24px;
	gap: 12px;
}

.cancel-button {
	border: 1px solid #d0d0d0;
	color: #5a5a5a;
	background: white;
	text-transform: none;
	font-weight: 500;
	height: 40px;
	min-width: 80px;
}

.cancel-button:hover {
	background: #f5f5f5;
	border-color: #bdbdbd;
}

.confirm-button {
	background: #66BB6A !important;
	color: white;
	text-transform: none;
	font-weight: 500;
	height: 40px;
	min-width: 80px;
	box-shadow: none;
}

.confirm-button:hover {
	background: #5cb85c !important;
}
</style> 